import moment from "moment-timezone";
import { groupDiscountPayload } from "./groupDiscount";
import { addDays, endsNextDay } from "./dateValue";

function combine(date, time, timeZone) {
  if (!date || !time) return undefined;
  const local = `${date}T${time}`;
  return timeZone ? moment.tz(local, timeZone).toISOString() : local;
}

function sessionAttributes(sessions, timeZone, attendanceChoice) {
  return sessions.map((s, idx) => {
    const attr = {
      name: (s.name || "").trim(),
      description: s.description || "",
      position: idx + 1,
      room_id: s.room_id || null,
      instructor_ids: s.instructor_ids || [],
    };
    const startsAt = combine(s.date, s.start, timeZone);
    const endsAt = combine(endsNextDay(s.start, s.end) ? addDays(s.date, 1) : s.date, s.end, timeZone);
    if (startsAt) attr.starts_at = startsAt;
    if (endsAt) attr.ends_at = endsAt;
    if (s.id) attr.id = s.id;
    if (attendanceChoice && attendanceChoice.sessionIds.includes(s.id)) attr.clear_attendance = attendanceChoice.clear;
    return attr;
  });
}

function registrationClosesAt(form, timeZone) {
  if (!form.registration_closes_date && !form.registration_closes_time) return null;
  return combine(form.registration_closes_date, form.registration_closes_time, timeZone) || null;
}

function registrationOpensAt(form, timeZone) {
  if (!form.registration_opens_date && !form.registration_opens_time) return null;
  return combine(form.registration_opens_date, form.registration_opens_time, timeZone) || null;
}

export default function buildClassInstancePayload({ form, sessions, existingSessions = null, timeZone = null, attendanceChoice = null }) {
  const attributes = sessionAttributes(sessions, timeZone, attendanceChoice);

  if (existingSessions) {
    const keptIds = new Set(sessions.filter((s) => s.id).map((s) => s.id));
    existingSessions.forEach((s) => {
      if (!keptIds.has(s.id)) attributes.push({ id: s.id, _destroy: true });
    });
  }

  return {
    class_template_id: form.class_template_id || null,
    venue_ownership_id: form.venue_ownership_id,
    name: (form.name || "").trim(),
    public_description: (form.public_description || "").trim() === "" ? "" : form.public_description,
    format: form.format,
    level: form.level || null,
    category: form.category || null,
    capacity: form.capacity === "" ? null : form.capacity,
    price: form.price === "" ? null : form.price,
    waitlist_enabled: form.waitlist_enabled,
    waitlist_claim_window_hours: form.waitlist_claim_window_hours,
    refund_window_days: form.refund_window_days,
    ...groupDiscountPayload(form),
    visibility: form.visibility,
    registration_closes_at: registrationClosesAt(form, timeZone),
    registration_opens_at: registrationOpensAt(form, timeZone),
    class_sessions_attributes: attributes,
  };
}
